import React, { useContext } from 'react';
import StyledPromptSuggestionListItem from '../../styles/StyledPromptSuggestionListItem';
import ChatsContext from '../../contexts/ChatsContext';
import AppContextType from '../../types/AppContextType';
import AppContext from '../../contexts/AppContext';

interface PromptSuggestionListItemProps {
  text: string;
}

const PromptSuggestionListItem = ({ text }: PromptSuggestionListItemProps) => {
  const { configuration } = useContext<AppContextType>(AppContext);
  const { sendChatMessage } = useContext(ChatsContext);

  const onClick = () => {
    sendChatMessage(text);
  };

  if (!configuration) return <></>;

  return (
    <StyledPromptSuggestionListItem onClick={onClick} $color={configuration.theme_color}>
      <div className='item'>{text}</div>
    </StyledPromptSuggestionListItem>
  );
};

export default PromptSuggestionListItem;